/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import './Analizador.css';
import { useTranslation } from 'react-i18next';

function Analizador(props) {
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code } = props;
    const { t } = useTranslation();
    var [EM, setEM] = useState([]);
    var [htmlEM, setHtmlEM] = useState(<></>);
    const variablesAPedir = "description,timeStamp,p,s,pF,q,wp_dmd,wp_sup,wq_ind,wq_cap,ws,iL1,iL2,iL3,uL1L2,uL2L3,uL3L1,pL1,pL2,pL3,qA,qB,qC,sA,sB,sC,pFa,pFb,pFc,thdsVaVab,thdsVbVbc,thdsVcVca,thdsIa,thdsIb,thdsIc,f";

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/energyMeter?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataEM) => { setEM(await dataEM.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/energyMeter?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataEM) => { setEM(await dataEM.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    useEffect(() => {
        htmlEM = EM.map((datoEM, index) => {
            const { description, timeStamp, p, s, pF, q, wp_dmd, wp_sup, wq_ind, wq_cap, ws, iL1, iL2, iL3, uL1L2, uL2L3, uL3L1, pL1, pL2, pL3, qA, qB, qC, sA, sB, sC, pFa, pFb, pFc,
                thdsVaVab, thdsVbVbc, thdsVcVca, thdsIa, thdsIb, thdsIc, f } = datoEM;
            return (
                <div className='col-12 col-sm-6'>
                    <h3>{description}</h3>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>{t('scada.solarFarm.analyzer.readingDate')}</th>
                                <th>{timeStamp}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {p ? <tr>
                                <td>{t('scada.solarFarm.analyzer.activePower')}</td>
                                <td><strong>{p}</strong></td>
                            </tr> : <></>}

                            {q ? <tr>
                                <td>{t('scada.solarFarm.analyzer.reactivePower')}</td>
                                <td><strong>{q}</strong></td>
                            </tr> : <></>}

                            {s ? <tr>
                                <td>{t('scada.solarFarm.analyzer.apparentPower')}</td>
                                <td><strong>{s} </strong></td>
                            </tr> : <></>}

                            {pF ? <tr>
                                <td>{t('scada.solarFarm.analyzer.powerFactor')}</td>
                                <td><strong>{pF}</strong></td>
                            </tr> : <></>}

                            {f ? <tr>
                                <td>{t('scada.solarFarm.analyzer.frequency')}</td>
                                <td><strong>{f}</strong></td>
                            </tr> : <></>}

                            {wp_dmd ? <tr>
                                <td>{t('scada.solarFarm.analyzer.activeEnergyDemand')}</td>
                                <td><strong>{wp_dmd}</strong></td>
                            </tr> : <></>}
                            
                            {wp_sup ? <tr>
                                <td>{t('scada.solarFarm.analyzer.activeEnergySupply')}</td>
                                <td><strong>{wp_sup}</strong></td>
                            </tr> : <></>}

                            {wq_ind ? <tr>
                                <td>{t('scada.solarFarm.analyzer.inductiveReactivePower')}</td>
                                <td><strong>{wq_ind}</strong></td>
                            </tr> : <></>}

                            {wq_cap ? <tr>
                                <td>{t('scada.solarFarm.analyzer.capacitiveReactivePower')}</td>
                                <td><strong>{wq_cap}</strong></td>
                            </tr> : <></>}

                            {ws ? <tr>
                                <td>{t('scada.solarFarm.analyzer.apparentEnergy')}</td>
                                <td><strong>{ws}</strong></td>
                            </tr> : <></>}

                            {iL1 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.currentA')}</td>
                                <td><strong>{iL1}</strong></td>
                            </tr> : <></>}

                            {iL2 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.currentB')}</td>
                                <td><strong>{iL2}</strong></td>
                            </tr> : <></>}

                            {iL3 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.currentC')}</td>
                                <td><strong>{iL3}</strong></td>
                            </tr> : <></>}

                            {uL1L2 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.voltageAB')}</td>
                                <td><strong>{uL1L2}</strong></td>
                            </tr> : <></>}

                            {uL2L3 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.voltageBC')}</td>
                                <td><strong>{uL2L3}</strong></td>
                            </tr> : <></>}

                            {uL3L1 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.voltageCA')}</td>
                                <td><strong>{uL3L1}</strong></td>
                            </tr> : <></>}

                            {pL1 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.activePowerA')}</td>
                                <td><strong>{pL1}</strong></td>
                            </tr> : <></>}

                            {pL2 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.activePowerB')}</td>
                                <td><strong>{pL2}</strong></td>
                            </tr> : <></>}

                            {pL3 ? <tr>
                                <td>{t('scada.solarFarm.analyzer.activePowerC')}</td>
                                <td><strong>{pL3}</strong></td>
                            </tr> : <></>}

                            {qA ? <tr>
                                <td>{t('scada.solarFarm.analyzer.reactivePowerA')}</td>
                                <td><strong>{qA}</strong></td>
                            </tr> : <></>}

                            {qB ? <tr>
                                <td>{t('scada.solarFarm.analyzer.reactivePowerB')}</td>
                                <td><strong>{qB}</strong></td>
                            </tr> : <></>}

                            {qC ? <tr>
                                <td>{t('scada.solarFarm.analyzer.reactivePowerC')}</td>
                                <td><strong>{qC}</strong></td>
                            </tr> : <></>}

                            {sA ? <tr>
                                <td>{t('scada.solarFarm.analyzer.apparentPowerA')}</td>
                                <td><strong>{sA}</strong></td>
                            </tr> : <></>}

                            {sB ? <tr>
                                <td>{t('scada.solarFarm.analyzer.apparentPowerB')}</td>
                                <td><strong>{sB}</strong></td>
                            </tr> : <></>}

                            {sC ? <tr>
                                <td>{t('scada.solarFarm.analyzer.apparentPowerC')}</td>
                                <td><strong>{sC}</strong></td>
                            </tr> : <></>}

                            {pFa ? <tr>
                                <td>{t('scada.solarFarm.analyzer.powerFactorA')}</td>
                                <td><strong>{pFa}</strong></td>
                            </tr> : <></>}

                            {pFb ? <tr>
                                <td>{t('scada.solarFarm.analyzer.powerFactorB')}</td>
                                <td><strong>{pFb}</strong></td>
                            </tr> : <></>}

                            {pFc ? <tr>
                                <td>{t('scada.solarFarm.analyzer.powerFactorC')}</td>
                                <td><strong>{pFc}</strong></td>
                            </tr> : <></>}

                            {thdsVaVab ? <tr>
                                <td>{t('scada.solarFarm.analyzer.thdsVa')}</td>
                                <td><strong>{thdsVaVab}</strong></td>
                            </tr> : <></>}

                            {thdsVbVbc ? <tr>
                                <td>{t('scada.solarFarm.analyzer.thdsVb')}</td>
                                <td><strong>{thdsVbVbc}</strong></td>
                            </tr> : <></>}

                            {thdsVcVca ? <tr>
                                <td>{t('scada.solarFarm.analyzer.thdsVc')}</td>
                                <td><strong>{thdsVcVca}</strong></td>
                            </tr> : <></>}

                            {thdsIa ? <tr>
                                <td>{t('scada.solarFarm.analyzar.thdsIa')}</td>
                                <td><strong>{thdsIa}</strong></td>
                            </tr> : <></>}

                            {thdsIb ? <tr>
                                <td>{t('scada.solarFarm.analyzar.thdsIb')}</td>
                                <td><strong>{thdsIb}</strong></td>
                            </tr> : <></>}

                            {thdsIc ? <tr>
                                <td>{t('scada.solarFarm.analyzar.thdsIc')}</td>
                                <td><strong>{thdsIc}</strong></td>
                            </tr> : <></>}
                        </tbody>
                    </Table>
                </div>
            );
        });
        setHtmlEM(htmlEM);
    }, [EM]);

    return (
        <div className='container-fluid div-janitza-tables' style={{ marginTop: '20px' }}>
            <div className='row'>
                {htmlEM}
            </div>
        </div>
    )
}

export default Analizador;